<template>
	<div>
		<h1>{{ page_title }}</h1>
		
		<div id="drop_file_zone" @drop="upload_file" ondragover="return false" v-if="docs.length === 0">
			<div id="drag_upload_file">
				<p>PDF-Dokumente hier hin ziehen</p>
				<p>oder</p>
				<p><button @click="file_explorer()">Datei(en) auswählen</button><!--input type="button" value="Datei(en) auswählen" @click="file_explorer()" /--></p>
				<input type="file" id="selectfile" multiple />
			</div>
		</div>
		
		<div class="doc-wrapper" v-for="(doc,idx) in docs" :key="idx">
			<div class="doc-thumbnail" :class="{nobg: doc.thumbnail !== ''}">
				<img :src="doc.thumbnail" v-if="doc.thumbnail !== ''">
				<div class="loadingio-eclipse" v-else-if="doc.err.msg === ''">
					<div class="ldio-rpinwye8j0b">
						<div></div>
					</div>
				</div>
			</div>
			<div class="doc-data">
				<div>
					<label>Dateiname</label>
					<input type="text" :value="doc.original_filename" readonly>
					
					<span v-if="doc.thumbnail !== ''">
						<label :for="'type_'+idx">Typ</label>
						<select :id="'type_'+idx" v-model="doc.type">
							<option value="ar">Debitorenrechnung</option>
							<option value="ap">Kreditorenrechnung</option>
						</select>
						<label :for="'pa_'+idx">Personenkonto</label>
						<div class="pactrl">
							<input type="text" :id="'pa_'+idx" :value="getPaLine(doc.pa)" readonly>
							<div @click="open_pa_modal(idx, doc.pa)"><i class="fas fa-pencil-alt"></i></div>
						</div>
						<div class="panew" v-if="doc.pa.id === 0 && doc.pa.name !== ''">
							Neues Personenkonto wird angelegt
						</div>
						<div class="dcwrapper">
							<div>
								<label :for="'date_'+idx">Rechnungsdatum</label>
								<input type="text" :id="'date_'+idx" v-model="doc.date">
							</div>
							<div>
								<label :for="'duedate_'+idx">Fälligkeitsdatum</label>
								<input type="text" :id="'duedate_'+idx" v-model="doc.duedate">
							</div>
						</div>
						
						<div class="dcwrapper">
							<div>
								<label :for="'name_'+idx" :class="{red_font: doc.doc_number.length>25}">Rechnungs-Nr. ({{ doc.doc_number.length }}/25)</label>
								<input type="text" :id="'name_'+idx" v-model="doc.doc_number">
							</div>
							<div>
								<label :for="'name_'+idx" :class="{red_font: doc.name.length>45}">Bezeichnung ({{ doc.name.length }}/45)</label>
								<input type="text" :id="'name_'+idx" v-model="doc.name">
							</div>
						</div>
						
						<div class="dcwrapper">
							<div>
								<label :for="'name_'+idx" :class="{red_font: doc.posting_txt.length>150}">Buchungstext ({{ doc.posting_txt.length }}/150)</label>
								<div class="pactrl">
									<input type="text" :id="'name_'+idx" v-model="doc.posting_txt">
									<div @click="suggest_posting_txt(idx)" style="padding-top: 1px;"><i class="fas fa-cog"></i></div>
								</div>
							</div>
							<div>
								<label :for="'amount_'+idx">Betrag{{ get_ccy(doc.pa, idx) }}</label>
								<input type="text" :id="'amount_'+idx" v-model="doc.amount">
								<div v-if="doc.hasOwnProperty('foreign_ccy') && doc.foreign_ccy">
									<label :for="'foreign_ccy_'+idx">Buchkurs</label>
									<input type="text" :id="'foreign_ccy_'+idx" v-model="doc.xchrate">
								</div>
							</div>
						</div>

						<div class="dcwrapper">
							<label :for="'debit_'+idx" class="solltit">Soll</label>
							<label :for="'credit_'+idx">Haben</label>
						</div>
						<div class="dcwrapper spaceafter">
							<div class="acctvat">
								<input type="text" class="acctfld" v-model.trim="doc.debit_acct" @change="checkAcct(idx, 'debit')" placeholder="Konto" :title="acct_name_lookup.hasOwnProperty(doc.debit_acct) ? acct_name_lookup[doc.debit_acct] : ''"/>
								<div class="btn" @click="selectShowDlg(idx, 'acct', 'debit')">
									<i class="far fa-list-alt"></i>
								</div>
								<input type="text" class="vatfld" v-model.trim="doc.debit_vat" @change="checkVAT(idx, 'debit')" placeholder="Mwst" :title="vat_name_lookup.hasOwnProperty(doc.debit_vat) ? vat_name_lookup[doc.debit_vat] : ''" :disabled="doc.credit_vat !== ''"/>
								<div class="btn" :class="doc.credit_vat !== '' ? 'disabled': ''" @click="selectShowDlg(idx, 'vat', 'debit')">
									<i class="far fa-list-alt"></i>
								</div>
							</div>
							<div class="acctvat">
								<input type="text" class="acctfld" v-model.trim="doc.credit_acct" @change="checkAcct(idx, 'credit')" placeholder="Konto" :title="acct_name_lookup.hasOwnProperty(doc.credit_acct) ? acct_name_lookup[doc.credit_acct] : ''"/>
								<div class="btn" @click="selectShowDlg(idx, 'acct', 'credit')">
									<i class="far fa-list-alt"></i>
								</div>
								<input type="text" class="vatfld" v-model.trim="doc.credit_vat" @change="checkVAT(idx, 'credit')" placeholder="Mwst" :title="vat_name_lookup.hasOwnProperty(doc.credit_vat) ? vat_name_lookup[doc.credit_vat] : ''" :disabled="doc.debit_vat !== ''"/>
								<div class="btn" :class="doc.debit_vat !== '' ? 'disabled': ''" @click="selectShowDlg(idx, 'vat', 'credit')">
									<i class="far fa-list-alt"></i>
								</div>
							</div>
						</div>

						<!--label :for="'debit_'+idx">Soll</label>
						<div class="acctinp"><input type="text" :id="'debit_'+idx"><input type="text" placeholder="MWST"></div>
						<label :for="'credit_'+idx">Haben</label>
						<div class="acctinp"><input type="text" :id="'credit_'+idx"><input type="text" placeholder="MWST"></div-->
						
						<label :for="'name_'+idx" :class="{red_font: doc.ref.length>50}">Referenznummer ({{ doc.ref.length }}/50)</label>
						<input type="text" :id="'name_'+idx" v-model="doc.ref">
						
						<div class="dcwrapper">
							<div>
								<label :for="'status_'+idx">Status</label>
								<select :id="'status_'+idx" v-model="doc.status">
									<option value="pending">in Arbeit</option>
									<option value="ready">freigegeben</option>
									<option value="submitted">übermittelt</option>
								</select>
							</div>
						</div>
					</span>
				</div>
				<div>
					<i class="fas fa-trash-alt right" title="Löschen" @click="deleteShowDlg(idx)" v-if="!editMode && (doc.thumbnail !== '' || doc.err.msg !== '')"></i><a :href="doc.thumbnail.replace('arapimg', 'arappdf')" target="_blank" v-if="doc.thumbnail !== ''"><i class="fas fa-file-pdf right rspace" title="PDF öffnen"></i></a><i class="fas fa-save right rspace hlight" title="Speichern" @click="saveDocument(idx)" v-if="doc.thumbnail !== ''"></i><span class="err" v-show="doc.err.msg !== ''">{{ doc.err.msg }}</span>
				</div>
			</div>
		</div>
		
		<modal name="modalPA" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Personenkonto</div>
			<div class="delConf-content">
				<div class="tabs-light">
					<div :class="{active: pa_dlg.tab === 'find'}" @click="pa_dlg.tab = 'find'">Suche</div>
					<div :class="{active: pa_dlg.tab === 'new'}" @click="pa_dlg.tab = 'new'">Neu</div>
				</div>
				
				<div v-if="pa_dlg.tab === 'find'">
					<div class="pactrl">
						<input type="text" v-model="pa_dlg.searchtxt" @keyup.enter="find_pa">
						<div @click="find_pa"><i class="fas fa-search"></i></div>
					</div>

					<select size="7" v-model="pa_dlg.selected_rec" @change="pa_selection_change">
						<option v-for="rec in pa_dlg.recs" :key="rec.id" :value="rec.id">{{ rec.name }}, {{ rec.street }}, {{ rec.location }}</option>
					</select>
					
					<label>Personenkontonummer</label>
					<input type="text" v-model="pa_dlg.number">
					
					<label>Währung</label>
					<select v-model="pa_dlg.currency">
						<option v-for="ccy in ccy_recs" :key="ccy.id" :value="ccy.id">{{ ccy.iso_code }} - {{ ccy.description }}</option>
					</select>
				</div>
				<div v-else>
					<label>Name</label>
					<input type="text" v-model="pa_dlg.name">
					
					<label>Strasse</label>
					<input type="text" v-model="pa_dlg.street">
					
					<label>PLZ/Ort</label>
					<input type="text" v-model="pa_dlg.location">
					
					<label>Land (Kürzel, z.B. CH)</label>
					<input type="text" v-model="pa_dlg.country">
					
					<label>Personenkontonummer</label>
					<input type="text" v-model="pa_dlg.number">
					
					<label>Währung</label>
					<select v-model="pa_dlg.currency">
						<option v-for="ccy in ccy_recs" :key="ccy.id" :value="ccy.id">{{ ccy.iso_code }} - {{ ccy.description }}</option>
					</select>
				</div>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="savePA" class="delConf-btn-del">Übernehmen</button>
				<button @click="$modal.hide('modalPA')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalSubmit" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Übermittlung bestätigen</div>
			<div class="delConf-content">
				'{{ selected_name }}' wirklich übermitteln?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="submitImportData" class="delConf-btn-del">Ja</button>
				<button @click="$modal.hide('modalSubmit')">Nein</button>
			</div>
		</modal>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Dokument '{{ selected_name }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalSelection" width="350" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.selsrch.focus()">
			<div class="delConf-title">{{ selection.title }} auswählen</div>
			<div class="delConf-content selectdlg">
				<input type="text" v-model="selection.searchtxt" placeholder="Suche..." ref="selsrch" /><br>
				<select size="8" v-model="selection.selected">
					<option v-for="(rec,idx) in selection_items" :key="idx" :value="rec.id">[{{ rec.id }}] {{ rec.name }}</option>
				</select>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="selectInsert" :disabled="selection.selected === ''">Auswählen</button>
				<button @click="$modal.hide('modalSelection')">Abbrechen</button>
			</div>
		</modal>
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			editMode: false,
			posting_txt_ar: '',
			posting_txt_ap: '',
			pa_dlg: {
				tab: 'new',
				searchtxt: '',
				recs: [],
				selected_rec: 0,
				idx: 0,
				id: 0,
				name: '',
				street: '',
				location: '',
				country: 'CH',
				number: '',
				currency: 0
			},
			docs: [

//				{"id":0,"date":"","name":"","type":"","amount":0,"debit_acct":"","debit_vat":"","credit_acct":"","credit_vat":"","payment_pending":true,"doc_checksum":"d748a90d54e954c489643eb884a944eca6f3b451a27d042843013e528a9b2076","original_filename":"rechnung_nr_586473.pdf","err":{"code":0,"msg":""}}

			],
			hndlEvent: 0,
			acct_recs: [],
			vat_recs: [],
			ccy_recs: [],
			acct_name_lookup: {},
			vat_name_lookup: {},
			selection: {
				title: '',
				searchtxt: '',
				selected: '',
				type: '', // 'acct' oder 'vat'
				side: '' // 'debit' oder 'credit'
			},
			selected_id: '',
			selected_name: '',




			recs: []
		}
	},
    computed: {
		client_id () {
			return this.$store.state.customer.id
		},
		
		page_title () {
			return this.editMode ? 'Dokument bearbeiten' : 'Dokumente verarbeiten';
		},
		
		localccy () {
			var idx = this.ccy_recs.findIndex(x => x.local === '1');
//console.log('localccy -> ' + idx)
			if (idx === -1) {
				return '';
			} else {
				return this.ccy_recs[idx].id;
			}
		},
		
		selection_items: function () {
			var stxt = this.selection.searchtxt.toLowerCase()
			var recs = this.selection.type === 'acct' ? this.acct_recs : this.vat_recs
			if (stxt === '') {
				return recs
			} else {
				var filtered = []
				var i
				for(i=0; i < recs.length; i++) {
					if (recs[i].id.toLowerCase().indexOf(stxt) > -1 || recs[i].name.toLowerCase().indexOf(stxt) > -1)
						filtered.push(recs[i])
				}
				return filtered
			}
		}
	},
    methods: {
		pa_selection_change(v) {
			var ccy_id,idx = this.pa_dlg.recs.findIndex(x => x.id === v.target.value);
//console.log('pa_selection_change -> ccy: ' + this.pa_dlg.currency); //debug
			if (idx !== -1) {
				ccy_id = this.pa_dlg.recs[idx].ccy_id;
				this.pa_dlg['currency'] = ccy_id === '0' ? this.localccy : ccy_id;
			} else this.pa_dlg['currency'] = this.localccy;
//console.log('pa_selection_change -> ccy: ' + this.pa_dlg.currency); //debug
		},
		
		suggest_posting_txt(idx) {
			var o = this.docs[idx], tpl, fld_matches, fields = [], s, i, n;
			
			if (o.type === 'ar') tpl = this.posting_txt_ar;
			else if (o.type === 'ap') tpl = this.posting_txt_ap;
			else {
				this.$snotify.error('Das Feld "Typ" darf nicht leer sein', 'Fehler', {timeout: 4000});
				return;
			}
			
			if (tpl === '') return;
			
			fld_matches = tpl.match(/{{\s*[a-z_]+\s*}}/gi);
			for (const fld of fld_matches) {
				s = fld.replace(/[{}\s]/g, '').toLowerCase();
				if (['firma_name','re_nr','re_name','re_datum'].indexOf(s) !== -1) fields.push({field: s, placeholder: fld});
			}
			
			//Felder identifizieren, überprüfen, ob sie Daten enthalten und Platzhalter durch Daten ersetzen
			n = fields.length;
			for (i=0; i<n; i++) {
				switch (fields[i].field) {
					case 'firma_name':
						if (o.pa.name === '') {
							this.$snotify.error('Personenkonto-Name darf nicht leer sein', 'Fehler', {timeout: 4000});
							return;
						}
						tpl = tpl.replace(fields[i].placeholder, o.pa.name);
						break;
					case 're_nr':
						if (o.doc_number === '') {
							this.$snotify.error('Rechnungsnummer darf nicht leer sein', 'Fehler', {timeout: 4000});
							return;
						}
						tpl = tpl.replace(fields[i].placeholder, o.doc_number);
						break;
					case 're_name':
						if (o.name === '') {
							this.$snotify.error('Bezeichnung darf nicht leer sein', 'Fehler', {timeout: 4000});
							return;
						}
						tpl = tpl.replace(fields[i].placeholder, o.name);
						break;
					case 're_datum':
						if (o.date === '') {
							this.$snotify.error('Rechnungsdatum darf nicht leer sein', 'Fehler', {timeout: 4000});
							return;
						}
						tpl = tpl.replace(fields[i].placeholder, o.date);
						break;
				}
			}
			
			this.docs[idx].posting_txt = tpl;
			this.docs.push({});
			this.docs.pop();
		},
		
		get_ccy(pa, i) {
//console.log('get_ccy -> ccy: ' + this.pa_dlg.currency); //debug
//console.log('get_ccy(' + JSON.stringify(pa) + ')');
			if (pa.currency === 0 || pa.currency.toString().trim() === '') return '';
			var idx = this.ccy_recs.findIndex(x => x.id === pa.currency), oldval;
			if (idx === -1) {
				pa.foreign_ccy = false;
				return '';
			} else {
//				oldval = pa.foreign_ccy;
//				pa.foreign_ccy = this.ccy_recs[idx].local == 0;
				oldval = this.docs[i]['foreign_ccy'];
				this.docs[i]['foreign_ccy'] = this.ccy_recs[idx].local == 0;
				if (oldval != this.docs[i]['foreign_ccy']) {
					this.docs.push({});
					this.docs.pop();
				}
//console.log('get_ccy -> this.ccy_recs[idx].local: ' + this.ccy_recs[idx].local);
//console.log('get_ccy -> foreign_ccy: ' + (pa.foreign_ccy === true ? 'TRUE' : 'FALSE'));
				return ' (' + this.ccy_recs[idx].iso_code + ')';
			}
			//return idx === -1 ? '' : ' (' + this.ccy_recs[idx].iso_code + ')';
		},
		
		find_pa() {
			var st = this.pa_dlg.searchtxt.toString().trim();
			this.pa_dlg.recs = [];
			if (st.length < 2) return;

			this.apiCall([{method: 'arap/acct/list', param: {quicksearch: st, opt_client_id: this.client_id}, id: 7}], this.evalApiResponse);
		},
		
		saveDocument(idx) {
			//TODO: Daten validieren
			var p = this.$_.cloneDeep(this.docs[idx]);
			delete p.err; //Error-Object wird fürs Speichern nicht benötigt

			var d = this.$moment(p.date, 'DD.MM.YYYY');
			if (!d.isValid()) {
				this.$snotify.error('Das Datum "' + p.date + '" ist ungültig', 'ERROR', {timeout: 8000});
				return;
			}
			p.date = d.format('YYYY-MM-DD');
			
			d = this.$moment(p.duedate, 'DD.MM.YYYY');
			if (!d.isValid()) {
				this.$snotify.error('Das Datum "' + p.date + '" ist ungültig', 'ERROR', {timeout: 8000});
				return;
			}
			p.duedate = d.format('YYYY-MM-DD');
//console.log('date: ' + JSON.stringify(p));


			this.selected_id = p.doc_checksum; //Wird später (in evalApiResponse) dazu verwendet, nach erfolgreichem Speichern das Dokument aus this.docs zu entfernen
			
			this.apiCall([{method: 'arap/document/save', param: p, id: 11}], this.evalApiResponse);
		},
		
		getPaLine(pa) {
			if (pa.name === '') return '';
			return pa.name + ', ' + pa.street + ', ' + pa.location;
		},
		
		savePA() {
/*
			pa_dlg: {
				tab: 'new',
				searchtxt: '',
				recs: [],
				idx: 0,
				id: 0,
				name: '',
				street: '',
				location: '',
				country: '',
			},
*/
			var vm = this, idx = vm.pa_dlg.idx, pa_idx, o;
			
//console.log('savePA -> ccy: ' + this.pa_dlg.currency); //debug
			if (vm.pa_dlg.tab === 'find') {
//console.log('FIND'); //debug
				pa_idx = vm.pa_dlg.recs.findIndex(x => x.id === vm.pa_dlg.selected_rec);
				if (pa_idx !== -1) {
//console.log('GEFINDET'); //debug
					o = vm.pa_dlg.recs[pa_idx];
					vm.pa_dlg.id = o.id;
					vm.pa_dlg.name = o.name;
					vm.pa_dlg.street = o.street;
					vm.pa_dlg.location = o.location;
					vm.pa_dlg.country = o.country;
					vm.pa_dlg.number = o.number;
					vm.pa_dlg['currency'] = o.ccy_id;
				}
			} else {
				if (vm.pa_dlg.name === '' || vm.pa_dlg.location === '') {
					vm.$snotify.error('Die Felder Name und PLZ/Ort müssen ausgefüllt werden', 'ERROR', {timeout: 8000});
					return;
				}
				
				if (vm.pa_dlg.country === '') vm.pa_dlg.country = 'CH';
			}
			
//console.log('GNN -> ' + JSON.stringify(vm.pa_dlg)); //debug
/*
{
  "tab": "find",
  "searchtxt": "ag",
  "recs": [
    {
      "id": "8",
      "name": "Webland AG",
      "street": "Emil Frey-Strasse 85",
      "location": "4142 Münchenstein",
      "country": "CH",
      "ccy_id": "3"
    },
    {
      "id": "10",
      "name": "unisite ag",
      "street": "Finkenstrasse 18",
      "location": "4104 Oberwil BL",
      "country": "CH",
      "ccy_id": "0"
    },
    {
      "id": "9",
      "name": "Primeo Netz AG",
      "street": "Weidenstrasse 27",
      "location": "4142 Münchenstein",
      "country": "CH",
      "ccy_id": "3"
    },
    {
      "id": "12",
      "name": "ImproWare AG",
      "street": "Zurlindenstrasse 29",
      "location": "4133 Pratteln",
      "country": "CH",
      "ccy_id": "0"
    },
    {
      "id": "7",
      "name": "Hostpoint AG",
      "street": "Neue Jonastrasse 60",
      "location": "8640 Rapperswil-Jona",
      "country": "CH",
      "ccy_id": "3"
    }
  ],
  "selected_rec": "10",
  "idx": 0,
  "id": "10",
  "name": "unisite ag",
  "street": "Finkenstrasse 18",
  "location": "4104 Oberwil BL",
  "country": "CH"
}

*/
			vm.docs[idx].pa.id = vm.pa_dlg.id;
			vm.docs[idx].pa.name = vm.pa_dlg.name;
			vm.docs[idx].pa.street = vm.pa_dlg.street;
			vm.docs[idx].pa.location = vm.pa_dlg.location;
			vm.docs[idx].pa.country = vm.pa_dlg.country;
			vm.docs[idx].pa.number = vm.pa_dlg.number;
			vm.docs[idx].pa.currency = vm.pa_dlg.currency;
			
			vm.docs.push({});
			vm.docs.pop();
			
			vm.$modal.hide('modalPA');
		},
		
		open_pa_modal(idx, pa) {
//console.log('open_pa_modal -> idx: ' + idx + ', pa: ' + JSON.stringify(pa));
			this.pa_dlg.recs = [];
			this.pa_dlg.searchtxt = '';
			this.pa_dlg.selected_rec = 0;
			this.pa_dlg.idx = idx;
			this.pa_dlg.id = pa.id;
			this.pa_dlg.name = pa.name;
			this.pa_dlg.street = pa.street;
			this.pa_dlg.location = pa.location;
			this.pa_dlg.country = pa.country === '' ? 'CH' : pa.country;
			this.pa_dlg.number = pa.number;
			this.pa_dlg.currency = pa.currency == '0' || pa.currency === '' ? this.localccy : pa.currency;
//console.log('open_pa_modal -> pa_dlg: ' + JSON.stringify(this.pa_dlg));

			this.$modal.show('modalPA');
		},
		
		selectShowDlg: function (rid, type, side) {
			var s = this.selection
			s.selected = ''
			if (type === 'vat') {
				if (side === 'debit' && this.docs[rid].credit_vat !== '') return
				if (side === 'credit' && this.docs[rid].debit_vat !== '') return
				s.selected = side === 'debit' ? this.docs[rid].debit_vat : this.docs[rid].credit_vat
			} else {
				s.selected = side === 'debit' ? this.docs[rid].debit_acct : this.docs[rid].credit_acct
			}

			this.selected_rid = rid

			s.title = type === 'vat' ? 'MWST-Code' : 'Fibu-Konto'
			s.searchtxt = ''
			s.type = type
			s.side = side

			this.$modal.show('modalSelection')
		},
		
		selectInsert: function () {
			var s = this.selection
			var is_debit = s.side === 'debit'
			var rid = this.selected_rid
			if (s.type === 'vat') {
				if (is_debit) this.docs[rid].debit_vat = s.selected
				else this.docs[rid].credit_vat = s.selected
			} else {
				if (is_debit)
					this.docs[rid].debit_acct = s.selected
				else
					this.docs[rid].credit_acct = s.selected
				this.checkAccount(rid, s.side, s.selected)
			}
			this.docs.push({});
			this.docs.pop();
			this.$modal.hide('modalSelection')
		},
		
		checkAccount: function (rid, side, acct) {
			//FIBU-Kto überprüfen und ggf. MWST-Code einfügen
			var i,vc
			for (i=0; i<this.acct_recs.length; i++) {
				if (this.acct_recs[i].id === acct) {
					vc = this.acct_recs[i].vat_code
					if (vc !== null) {
						if (side === 'debit') {
							if (this.docs[rid].credit_vat === '') this.docs[rid].debit_vat = vc
						} else {
							if (this.docs[rid].debit_vat === '') this.docs[rid].credit_vat = vc
						}
					}
					return true
				}
			}
			return false
		},
		
		checkAcct: function (rid, side) {
			if (this.docs[rid].debit_acct === '' || this.docs[rid].credit_acct === '') this.docs[rid].approved = false
			
			if (this.docs[rid].debit_acct !== '' && this.docs[rid].debit_acct === this.docs[rid].credit_acct)
				this.$snotify.error('Soll- und Haben-Konto dürfen nicht identisch sein', 'ERROR', {timeout: 8000})
			
			var acct = side === 'debit' ? this.docs[rid].debit_acct : this.docs[rid].credit_acct
			if (acct !== '' && !this.checkAccount(rid, side, acct))
				this.$snotify.error('Fibu-Konto "' + acct + '" ist ungültig', 'ERROR', {timeout: 8000})
		},
		
		checkVAT: function (rid, side) {
			var i, vat = side === 'debit' ? this.docs[rid].debit_vat : this.docs[rid].credit_vat
			if (vat === '') return
			for (i=0; i<this.vat_recs.length; i++) {
				if (this.vat_recs[i].id === vat) return
			}
			this.$snotify.error('MWST-Code "' + vat + '" ist ungültig', 'ERROR', {timeout: 8000})
		},
		
		upload_file(e) {
			e.preventDefault();
			this.ajax_file_upload(e.dataTransfer.files);
		},
  
		file_explorer() {
			var vm = this;
			document.getElementById('selectfile').click();
			document.getElementById('selectfile').onchange = function() {
				var files = document.getElementById('selectfile').files;
				vm.ajax_file_upload(files);
			};
		},

		ajax_file_upload(files_obj) {
			var i, o, n, xhttp, vm = this;
			if (files_obj != undefined) {
				var form_data = new FormData();
				form_data.append('client_id', vm.client_id);
				form_data.append('user_id', vm.$store.state.auth.user_id);
				for (i=0; i<files_obj.length; i++) {
					form_data.append('file[]', files_obj[i]);
				}
				xhttp = new XMLHttpRequest();
				xhttp.open("POST", vm.$globals.API_REL_URL + "arapul.php", true);
				xhttp.onload = function(event) {
					if (xhttp.status == 200) {
						//Upload war erfolgreich, jetzt soll mit dem Erkennen und Einlesen der Daten begonnen werden -> dazu arapul_evt.php aufrufen
						//alert(this.responseText);
//						console.log(JSON.stringify(event));
//						console.log(this.responseText);
						vm.docs = JSON.parse(this.responseText);
						
						//Alle foreign_ccy-Flags default-mässig auf FALSE setzen
						o = vm.docs;
						n = o.length;
						for (i=0; i<n; i++) o[i]['foreign_ccy'] = false;
						
//						vm.hndlEvent = new EventSource("//localhost/iceapi/arapul_evt.php?a=" + vm.$store.state.auth.user_id);
						vm.hndlEvent = new EventSource(vm.$globals.API_REL_URL + "arapul_evt.php?a=" + vm.$store.state.auth.user_id);

						vm.hndlEvent.addEventListener('update', function(event) {
							//Wird ausgelöst wenn Stammdaten aktualisiert wurden (INSERT oder UPDATE)
							vm.data_update_handler(JSON.parse(event.data));
						});

						vm.hndlEvent.addEventListener('close', function(event) {
							vm.hndlEvent.close();
							vm.hndlEvent = 0;
							//Meldung in event.data dem User anzeigen -> nur wenn JSON.parse(event.data).msg !== 'normal'
							i = JSON.parse(event.data);
							if (i.msg !== 'normal') vm.$snotify.error(i.msg, 'ERROR', {timeout: 8000})
						});

					} else {
						alert("Error " + xhttp.status + " occurred when trying to upload your file.");
					}
				}

				xhttp.send(form_data);
			}
		},
		
		format_values(idx) {
			var pt;
			
			if (this.docs[idx].date.indexOf('-') > -1) this.docs[idx].date = this.$moment(this.docs[idx].date, 'YYYY-MM-DD').format('DD.MM.YYYY');
			if (this.docs[idx].duedate.indexOf('-') > -1) this.docs[idx].duedate = this.$moment(this.docs[idx].duedate, 'YYYY-MM-DD').format('DD.MM.YYYY');
			
			if ((pt = this.docs[idx].amount.toString().indexOf('.')) > -1 && (this.docs[idx].amount.toString().length - pt - 1) === 1) this.docs[idx].amount += '0';
			if (pt === -1 && this.docs[idx].amount.toString().trim().length > 0) this.docs[idx].amount += '.00';
		},
		
		data_update_handler(data) {
//			console.log('data_update_handler -> ' + JSON.stringify(data));
//			console.log('data_update_handler -> data.doc_checksum -> ' + data.doc_checksum);
			var idx = this.docs.findIndex(x => x.doc_checksum === data.doc_checksum);
//			console.log('data_update_handler -> idx -> ' + idx);
			if (idx !== -1) {
				this.docs[idx] = data;
				
				this.format_values(idx);
				
				this.docs.push({});
				this.docs.pop();
			}
/*
{
  "id": 0,
  "date": "",
  "name": "",
  "type": "",
  "amount": 0,
  "debit_acct": "",
  "debit_vat": "",
  "credit_acct": "",
  "credit_vat": "",
  "payment_pending": true,
  "doc_checksum": "147f68cf2fd3c4497df28311ef70c2c68f8c8249b195285e25b12a1131180d11",
  "original_filename": "RE21122701-pesaris.pdf",
  "err": {
    "code": 0,
    "msg": ""
  }
}

*/
		},
		
		deleteShowDlg: function (idx) {
			this.selected_id = idx;
			this.selected_name = '';
			this.selected_name = this.docs[idx].original_filename;
			this.$modal.show('modalDel');
		},
		
		deleteRec: function () {
			var vm = this, chksum = vm.docs[vm.selected_id].doc_checksum;
			
			if (chksum === '') vm.docs.splice(vm.selected_id, 1);
			else vm.apiCall([{method: 'arap/document/delete', param: {checksum: chksum, client_id: vm.client_id}, id: 12}], vm.evalApiResponse);
			
			vm.$modal.hide('modalDel');
		},

















		status_label(status) {
			switch (status) {
				case 'pending': return 'in Arbeit';
				case 'ready': return 'freigegeben';
				case 'submitted': return 'übermittelt';
				default: return '';
			}
		},
		editImportData: function (rid) {
			var vm = this
			vm.apiCall([{method: 'import/load', param: {id: rid}, id: 20}], vm.evalApiResponse)
		},
		submitShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalSubmit')
		},
		submitImportData: function () {
			var vm = this, rid = vm.selected_id
			vm.apiCall([{method: 'import/submit/enter', param: {import_id: rid}, id: 30},{method: 'import/list', param: {client_id: vm.client_id}, if: [{id: 30, path: 'result/success', eq: true}], id: 10}], vm.evalApiResponse)
			this.$modal.hide('modalSubmit')
		},
		populateDT: function () {
//			var vm = this
//			vm.apiCall([{method: 'arap/document/list', param: {client_id: vm.client_id}, id: 10}], vm.evalApiResponse)
		},
		evalApiResponse: function (resp) {
			var vm = this, i, o;
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 1: // 1 = Result from 'arap/document/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						o = value.result;
//console.log('arap/document/load RESP -> o.pa.currency -> ' + o.pa.currency);
						if (o.pa.currency !== 0 && o.pa.currency.toString().trim() !== '') {
//console.log('ccy_recs -> ' + JSON.stringify(vm.ccy_recs));
							var idx = vm.ccy_recs.findIndex(x => parseInt(x.id) === parseInt(o.pa.currency));
//console.log('idx -> ' + idx);
							if (idx === -1) o['foreign_ccy'] = false;
							else o['foreign_ccy'] = vm.ccy_recs[idx].local === '0';
//console.log('foreign_ccy -> ' + (o['foreign_ccy'] ? 'TRUE' : 'FALSE'));
						}
						
						vm.docs = [];
						vm.docs.push(value.result);
						vm.format_values(0);
					}
				  case 7: // 7 = Result from 'arap/acct/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.pa_dlg.recs = value.result;
					}
				  case 10: // 10 = Result from 'import/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
/*
{
  "result": [
    {
      "id": "3",
      "date": "2022-03-06",
      "name": "Test",
      "type": "ar",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "submitted"
    },
    {
      "id": "2",
      "date": "2022-02-06",
      "name": "Test",
      "type": "ap",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "ready"
    },
    {
      "id": "1",
      "date": "2022-01-06",
      "name": "Test",
      "type": "ap",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "pending"
    }
  ],
  "id": 10
}
*/
						vm.recs = value.result
					}
					break
				  case 11: // 11 = Result from 'arap/document/save'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (vm.editMode) {
							vm.$router.push({ path: '/home/arap'})
							return;
						}
						
						i = vm.docs.findIndex(x => x.doc_checksum === vm.selected_id);
						if (i !== -1) vm.docs.splice(i, 1);
						vm.$snotify.success('Die Daten wurden gespeichert', 'OK');
					}
					break
				  case 12: // 12 = Result from 'arap/document/delete'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.docs.splice(vm.selected_id, 1);
					}
					break
				  case 20: // 20 = Result from 'import/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.$store.commit('set_import_param', value.result)
						vm.$router.push({ path: '/home/import/upload'})
					}
					break
				  case 30: // 30 = Result from 'import/submit/enter'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('incomplete')) vm.$snotify.error('Die Daten wurden übermittelt. Siehe Buchungsprotokoll für Details.', 'ERROR', {timeout: 8000})
						else vm.$snotify.success('Die Daten wurden verbucht', 'OK')
					}
					break
				  case 40: // 40 = Result from 'client/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.posting_txt_ar = value.result.posting_txt_ar;
						vm.posting_txt_ap = value.result.posting_txt_ap;
					}
					break
				  case 50: // 50 = Result from 'client/param/account/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						//vm.acct_recs = value.result
						vm.acct_recs = []
						for (i=0; i<value.result.length; i++) {
							vm.acct_recs.push({id: value.result[i].number, name: value.result[i].description, type: value.result[i].type, currency: value.result[i].currency, vat_code: value.result[i].vat_code})
							vm.acct_name_lookup[value.result[i].number] = value.result[i].description
						}
					}
					break
				  case 60: // 60 = Result from 'client/param/vat/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						//vm.vat_recs = value.result
						vm.vat_recs = []
						for (i=0; i<value.result.length; i++) {
							vm.vat_recs.push({id: value.result[i].code, name: value.result[i].description})
							vm.vat_name_lookup[value.result[i].code] = value.result[i].description
						}
					}
					break
				  case 70: // 70 = Result from 'client/param/currency/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.ccy_recs = value.result;
//						vm.ccy_recs.push({});
//						vm.ccy_recs.pop();
					}
					break
				}
			  }
			})
		}
    },
    filters: {
		recdate: function (val) {
			var a = val.substr(0,10).split('-')
			return a[2] + '.' + a[1] + '.' + a[0]
		},
		recstatus: function (val) {
			switch(val) {
				case 'PENDING': return 'AUSSTEHEND'
				case 'DOWNLOADED': return 'HERUNTERGELADEN'
				case 'SUBMITTED': return 'ÜBERMITTELT'
				default: return ''
			}
		}
    },
    watch: {
		client_id (newVal, oldVal) {
//			this.populateDT()
		}
    },
    mounted: function () {
//		this.populateDT()
		var cid = this.$store.state.customer.id, c;
		c = [{method: 'client/param/account/list', param: {client_id: cid}, id: 50},{method: 'client/param/vat/list', param: {client_id: cid}, id: 60},{method: 'client/param/currency/list', param: {client_id: cid}, id: 70},{method: 'client/load', param: {id: cid}, id: 40}];
		
		if (this.$route.path.indexOf('arap/document/edit') !== -1) {
			this.editMode = true;
			c.push({method: 'arap/document/load', param: {id: this.$route.params.id}, id: 1});
		}
		
		this.apiCall(c, this.evalApiResponse)
//		console.log(this.$route);
//		this.id = this.$route.params.id
//		this.apiCall([{method: 'client/load', param: {id: this.id}, id: 7}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
.fas.right {
	float: right;
	cursor: pointer;
}

.fas.rspace {
	margin-right: 10px;
}

label {
	display: block;
	font-size: 85%;
	margin-bottom: 3px;
}

input[type=text],select {
	width: 100%!important;
	margin-bottom: 10px;
}

input:read-only {
	background: #eee!important;
}

.acctinp {
	display: flex;
}

.acctinp > input:last-child {
	width: 75px!important;
	margin-left: 5px;
}

input.chkop {
	outline: 1px solid #888;
	width: 10px;
	height: 10px;
	-moz-appearance:none;
	-webkit-appearance:none;
	-o-appearance:none;
}

label.chkop {
	display: inline;
}

#drop_file_zone {
	background-color: #EEE;
	border: #999 5px dashed;
	width: 100%;
	padding: 8px;
	font-size: 18px;
}

#drag_upload_file {
	width: 65%;
	margin: 0 auto;
}

#drag_upload_file p {
	text-align: center;
}

#drag_upload_file #selectfile {
	display: none;
}


.doc-wrapper {
	display: inline-flex;
	width: 600px;
	background: #fff;
	margin: 20px 20px 0 0;
	padding: 10px;
	border: 1px solid #888;
}

.doc-thumbnail {
	background: #ccc;
	width: 300px;
	height: 430px;
	margin-right: 10px;
}

.doc-thumbnail.nobg {
	background: #fff;
}

.doc-thumbnail img {
	border: 1px solid #888;
}

.doc-data {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}

.doc-data > div:first-child {
	flex-grow: 1;
	flex-shrink: 1;
	overflow-y: auto;
}

.doc-data > div:last-child {
	flex-grow: 0;
	flex-shrink: 0;
	height: 25px;
	margin-top: 5px;
	border-top: 1px solid #bbb;
	padding-top: 5px;
}

.doc-data a {
	color: inherit;
}

.err {
	color: red;
}

button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.ar {
	background: #1E90FF;
}

.badge.ap {
	background: #AF04AF;
}

.badge.pending {
	background: #888;
}

.badge.ready {
	background: #FFA500;
}

.badge.submitted {
	background: #008000;
}


@keyframes ldio-rpinwye8j0b {
  0% { transform: rotate(0deg) }
  50% { transform: rotate(180deg) }
  100% { transform: rotate(360deg) }
}
.ldio-rpinwye8j0b div {
  position: absolute;
  animation: ldio-rpinwye8j0b 1s linear infinite;
  width: 40px;
  height: 40px;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  box-shadow: 0 3px 0 0 #4D4D4D;
  transform-origin: 20px 20px;
}
.loadingio-eclipse {
	display: block;
	margin-left: 105px;
	margin-top: 150px;
	width: 100px;
	height: 100px;
	overflow: hidden;
}
.ldio-rpinwye8j0b {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-rpinwye8j0b div { box-sizing: content-box; }

.dcwrapper {
	display: flex;
}

.dcwrapper > div:first-child, .dcwrapper > label:first-child {
	margin-right: 5px;
	width: 50%;
	flex-shrink: 0;
}

.acctvat {
	display: flex;
	border: 1px solid #888;
}

.acctvat input {
	border: none;
}

.acctvat .btn {
	cursor: pointer;
	background: #888;
	color: #fff;
	padding: 0 3px;
}

.acctvat .btn:hover {
	background: #666;
}

.acctvat .btn.disabled {
	cursor: auto;
	background: #888;
	color: #bbb;
}

.acctvat .btn.disabled:hover {
	background: #888;
}

.acctvat i {
	margin-top: 4px;
}

.acctvat input[type="text"] {
	margin: 0;
}

.acctfld {
/*	width: 60px;*/
}

.acctfld::placeholder {
	color: #888;
}

.vatfld {
/*	width: 50px;*/
}

.vatfld::placeholder {
	color: #888;
}

.vatfld:disabled::placeholder {
	color: #ddd;
}

.vatfld:disabled {
	background: #ddd;
}

.solltit {
	width: 50%;
}

.pactrl {
	display: flex;
}

.pactrl > div {
	background: #888;
	color: #fff;
	border: 1px solid #888;
	border-left: none;
	height: 24px;
	padding: 0 4px;
	cursor: pointer;
}

.pactrl > div:hover {
	background: #666;
}

.panew {
	color: #080;
	font-size:85%;
	margin-top: -10px;
	margin-bottom: 10px;
}

.tabs-light {
	display: flex;
	line-height: 35px;
	margin-bottom: 10px;
	cursor: pointer;
}

.tabs-light > div {
	padding: 0 10px;
	width: 50%;
	border: 1px solid #888;
	text-align: center;
}

.tabs-light > div:last-child {
	border-left: none;
}

.tabs-light .active {
	background: #eee;
	font-weight: 700;
}

.delConf-content .fa-search {
	margin-top: 3px;
}

.chkbxonly {
	padding-top: 20px;
}

.dcwrapper.spaceafter {
	padding-bottom: 10px;
}






/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.disabled {
	cursor: auto;
	color: #aaa;
}

.anl {
	text-decoration: none;
	color: #000;
}

.fa-save.hlight {
	color: #0A0;
	font-size: 125%;
	margin-right: 15px;
}

.red_font {
	color: #f00!important;
}
</style>
